import React from 'react';
import './style.scss';

interface CreditLineInvoiceDetail {
  creditLineInvoiceDetailId: number;
  bookingId: number;
  paid: boolean;
  paidDate: string;
  amount: number;
}

interface RecordType {
  creditLineInvoiceId: number;
  created: string;
  amount: number;
  urlPdf: string;
  dueDate: string;
  comments: string;
  paymentStatus: string;
  paidDate: string;
  accountName: string;
  creditLineInvoiceDetails: CreditLineInvoiceDetail[];
}

interface CompanyStatementDetailsProps {
  record: RecordType;
}


const CompanyStatementDetails: React.FC<CompanyStatementDetailsProps> = ({ record }) => {
  const formatAmount = (amount: any) => {
    if (typeof amount === 'number') {
      return `$${amount.toFixed(2)}`;
    } else if (typeof amount === 'string') {
      const parsedAmount = parseFloat(amount);
      return isNaN(parsedAmount) ? amount : `$${parsedAmount.toFixed(2)}`;
    }
    return amount;
  };
  return (
    <div className="bookingDetail">
      <h2>Invoice Overview</h2>
      <div className="row g-4 justify-content-center">
        <div className="col-lg-4">
          <div className="bookingDetail_item">
            <h3>Status</h3>
            <span>{record.paymentStatus}</span>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="bookingDetail_item">
            <h3>Invoice</h3>
            <span>{record.creditLineInvoiceId}</span>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="bookingDetail_item">
            <h3>Invoice Total</h3>
            <span>{formatAmount(record.amount)}</span>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="bookingDetail_item">
            <h3>Paid ON</h3>
            <span>{record.paidDate}</span>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="bookingDetail_item">
            <h3>Start Date</h3>
            <span>{record.created}</span>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="bookingDetail_item">
            <h3>End Date</h3>
            <span>{record.paidDate}</span>
          </div>
        </div>
      </div>
      <div className='mt-4 d-flex flex-column' id="record-list">
        <h2 className="mt-3">Bookings</h2>
        <div className="invoice-row bg-secondary text-white">
          <div className="invoice-cell">Invoice ID</div>
          <div className="invoice-cell">Booking ID</div>
          <div className="invoice-cell">Paid</div>
          <div className="invoice-cell">Paid Date</div>
          <div className="invoice-cell">Amount</div>
        </div>
        {record.creditLineInvoiceDetails?.map((record, index) => (
          <div className="invoice-row" key={record.creditLineInvoiceDetailId}>
            <div className="invoice-cell">{record.creditLineInvoiceDetailId}</div>
            <div className="invoice-cell">{record.bookingId}</div>
            <div className="invoice-cell">{record.paid.toString()}</div>
            <div className="invoice-cell">{record.paidDate}</div>
            <div className="invoice-cell">{formatAmount(record.amount)}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CompanyStatementDetails;
